import { View, StyleSheet } from 'react-native'
import { DS } from '../../design-system'
import { MaterialIcons } from '@expo/vector-icons'

interface ISectionTitle {
  title: string
  subtitle?: string
}

export const SectionTitle = ({ title, subtitle }: ISectionTitle) => {
  return (
    <View style={styles.container}>
      <DS.Frame style={styles.titleContainer}>
        <DS.Text variant="Heading 1/Medium">{title}</DS.Text>
      </DS.Frame>
      {subtitle ? (
        <DS.Frame style={styles.subtitleContainer}>
          <DS.Text variant="Body Medium/Regular" color="Brand/Dark Grey">
            {subtitle}
          </DS.Text>
        </DS.Frame>
      ) : null}
    </View>
  )
}

// styles
const styles = StyleSheet.create({
  container: {
    gap: 4
  },
  titleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16
  },
  subtitleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4
  }
})
